export const LOGO_URL = "/img/retard-logo.png";

// User-supplied memes — locally hosted + watermark-stripped versions.
export const MEMES = [
  { src: "/memes/meme-01.jpg", caption: "this is $RETARD coin. that's the whole pitch.", rotation: -3 },
  { src: "/memes/meme-02.jpg", caption: "the official $RETARD mascot. say hi.", rotation: 3 },
  { src: "/memes/meme-03.jpg", caption: "found the diamond. holding forever.", rotation: -4 },
  { src: "/memes/meme-04.jpg", caption: "nothing ever happens... I'M ALL IN.", rotation: 2 },
  { src: "/memes/meme-05.jpg", caption: "comfy in the chair. bags loaded.", rotation: -2 },
  { src: "/memes/meme-06.jpg", caption: "f*** the bots. we ride manually.", rotation: 3 },
  { src: "/memes/meme-07.jpg", caption: "first retard in space. NASA called. we hung up.", rotation: -3 },
  { src: "/memes/meme-08.jpg", caption: "caught in 4k. arrested for being too retarded.", rotation: 2 },
  { src: "/memes/meme-09.jpg", caption: "summer in the backyard. checkin' the chart.", rotation: -2 },
  { src: "/memes/meme-10.jpg", caption: "is this a pigeon? is this the bottom?", rotation: 3 },
  { src: "/memes/meme-11.jpg", caption: "i take me spinach. and flout the gaods.", rotation: -3 },
  { src: "/memes/meme-12.jpg", caption: "ah shit, here we go again.", rotation: 2 },
  { src: "/memes/meme-13.jpg", caption: "big d... is back in town. line go up.", rotation: -4 },
  { src: "/memes/meme-14.jpg", caption: "counting the bag. tongue out. fully retarded.", rotation: 3 },
  { src: "/memes/meme-15.jpg", caption: "blessed by the sun gods. middle fingers up. gmi.", rotation: -3 },
  { src: "/memes/meme-16.jpg", caption: "kim jong retard. time pill arc. take your meds.", rotation: 2 },
  { src: "/memes/meme-17.jpg", caption: "raw dogging the chart in star jammies. degen szn.", rotation: -3 },
  { src: "/memes/meme-18.jpg", caption: "kicking the bear off the cliff. risk management.", rotation: 3 },
  { src: "/memes/meme-19.jpg", caption: "u mad bro? sitting on the bag. tongue out. fully won.", rotation: -2 },
  { src: "/memes/meme-20.jpg", caption: "lone retard at the diner. ordering a green candle.", rotation: 3 },
  { src: "/memes/meme-21.jpg", caption: "lighting the bag on fire. literally. degen.", rotation: -3 },
  { src: "/memes/meme-22.jpg", caption: "hand out. tongue out. sending it to heaven.", rotation: 2 },
  { src: "/memes/meme-23.jpg", caption: "the senator finally took off the suit and put on the hat.", rotation: -2 },
  { src: "/memes/meme-24.jpg", caption: "$RETARD: san andreas. wanted level 5. cigar lit.", rotation: 3 },
];

// Drop a real Elon pic URL here later (square works best).
export const ELON_PHOTO_URL = "/img/elon-king.png";

export const TAGLINES = [
  "We are retarded and delusional and want big price",
  "We are retarded and delusional want big price",
  "We are retarded and delusional big price",
  "We are retarded and delusional",
  "We are retarded delusional",
  "We are retarded",
  "We retarded",
  "Retarded",
  "Retard",
];

export const CONTRACT_ADDRESS = "2q68mqEbjwmnMjs1o3KZDNZVyMv6RZKkHcm64iinpump";

// Live links.
export const PUMPFUN_URL = `https://pump.fun/coin/${CONTRACT_ADDRESS}`;
export const DEXSCREENER_URL = "https://dexscreener.com/solana/4FsJvbRPUs55eXoR2mLdbAKhceusQxSyK5NDu62ntQme";
export const DEXTOOLS_URL = "https://www.dextools.io/app/solana/pair-explorer/4FsJvbRPUs55eXoR2mLdbAKhceusQxSyK5NDu62ntQme";
export const FOMO_URL = "https://fomo.family/coin?address=2q68mqEbjwmnMjs1o3KZDNZVyMv6RZKkHcm64iinpump&chainId=1399811149&r=MrYungPat&source=share_link";
export const MOBYSCREENER_URL = "https://twitter.mobyscreener.com/solana/2q68mqEbjwmnMjs1o3KZDNZVyMv6RZKkHcm64iinpump?app_url=https%3A%2F%2Finvite.mobyscreener.com%2FrdFWn1Okd4b&v=1782247512";
export const TELEGRAM_URL = "https://t.me/retardcoinn";
export const TWITTER_URL = "https://x.com/Retardfirm";

// Back-compat alias used by ContractCard.
export const PLACEHOLDER_CA = CONTRACT_ADDRESS;

export const SOCIALS = [
  { label: "Twitter / X",  emoji: "X",    color: "blue",   href: TWITTER_URL },
  { label: "Telegram",     emoji: "TG",   color: "blue",   href: TELEGRAM_URL },
  { label: "Pump.fun",     emoji: "PUMP", color: "green",  href: PUMPFUN_URL },
  { label: "Dexscreener",  emoji: "DEX",  color: "red",    href: DEXSCREENER_URL },
  { label: "Dextools",     emoji: "TOOLS",color: "yellow", href: DEXTOOLS_URL },
  { label: "Mobyscreener", emoji: "MOBY", color: "blue",   href: MOBYSCREENER_URL },
  { label: "Fomo",         emoji: "FOMO", color: "red",    href: FOMO_URL },
];
